import { IsLocation, Bearing } from "../../geography";
import { IsTileSystemBounds } from "../tiles.interfaces";
export function HasNavigationState(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.navigationState !== undefined;
}
export function IsTileNavigationState(b) {
    if (b === null || typeof b !== "object")
        return false;
    return (b.center !== undefined &&
        IsLocation(b.center) &&
        b.zoom !== undefined &&
        b.azimuth !== undefined &&
        b.azimuth instanceof Bearing &&
        b.bounds !== undefined &&
        IsTileSystemBounds(b.bounds));
}
export function IsTileNavigationApi(b) {
    if (b === null || typeof b !== "object")
        return false;
    return (b.setViewMap !== undefined &&
        b.zoomInMap !== undefined &&
        b.zoomOutMap !== undefined &&
        b.translateUnitsMap !== undefined &&
        b.translateMap !== undefined &&
        b.rotateMap !== undefined);
}
export function HasNavigationApi(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.navigationApi !== undefined;
}
//# sourceMappingURL=tiles.navigation.interfaces.js.map